<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content" ref="content">
      <!-- <div class="countryList">
        <div class="country">
            <span>乡镇：</span>
        </div>
        <div class="country">
            <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
        </div>
        <div class="country" v-for="(item,index) in mutiRanksAdcd" :key="'q'+item.adcd">
            <span @click="setListCheck(index, item)" :class="{ countryon: item.check }">{{item.label}}</span>
        </div>
      </div> -->
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">水库名称:</span>
          <div class="selcountry">
            <el-input v-model="query.searchName" clearable placeholder="请输入" @change="Global.emptyQuery(query.searchName,searchTheData)"></el-input>
          </div>
          <span class="xzqh">工程类别:</span>
          <div class="selcountry">
            <el-select v-model="query.reservoirScale" clearable filterable placeholder="请选择" @change="Global.emptyQuery(query.reservoirScale,searchTheData)">
            <el-option
                v-for="item in reservoirScales"
                :key="'q'+item.id"
                :label="item.remark"
                :value="item.name">
              </el-option>
          </el-select>
          </div>
          <span class="xzqh">所属小流域:</span>
          <div class="selcountry">
          <el-select v-model="query.cacd" clearable filterable placeholder="请选择" @change="Global.emptyQuery(query.cacd,searchTheData)">
            <el-option
                v-for="item in cacds"
                :key="'q'+item.cacd"
                :label="item.canm"
                :value="item.cacd">
              </el-option>
          </el-select>
          </div>

          <span id="search" @click="searchTheData">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>

        </div>
        <div class="tablebox" v-loading = loading>
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow"  v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column fixed type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column fixed type="index"
                               width="60" label="序号"
                               align="center" header-align="center"
                               :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
              </el-table-column>
              <el-table-column  fixed  align="center" prop="reservoirName" label="水库名称" width="100">
              </el-table-column>
              <el-table-column  fixed align="center" prop="adcdnm" label="乡镇" width="120">
              </el-table-column>
              <el-table-column align="center" prop="canm" label="所属小流域" width="100">
              </el-table-column>
              <el-table-column fixed  align="center" prop="reservoirScale" label="工程类别" width="90">
              <template slot-scope="scope">
                {{getReservoirScaleName(scope.row)}}
              </template>
              </el-table-column>
              <el-table-column align="center" prop="rvnm" label="所在河流" width="85">
              </el-table-column>
              <el-table-column align="center" prop="rType" label="水库类型" width="90">
              </el-table-column>
              <el-table-column align="center" prop="barrageType" label="主要挡水建@筑物类型" :render-header="renderheader" width="100">
              </el-table-column>
              <el-table-column align="center" prop="releaseType" label="挡水主坝类型" width="120">
              </el-table-column>
              <el-table-column align="center" prop="releaseBuildType" label="主要泄洪建@筑物型式" :render-header="renderheader" width="100">
              </el-table-column>
              <el-table-column align="center" prop="flow" label="坝址多年平均径流量@(万m³/s)" :render-header="renderheader" width="160">
              </el-table-column>
              <el-table-column align="center" prop="damHeight" label="主坝坝高@(m)" :render-header="renderheader" width="85">
              </el-table-column>
              <el-table-column align="center" prop="damLength" label="主坝坝长@(m)" :render-header="renderheader" width="85">
              </el-table-column>
              <el-table-column  align="center" prop="maxFlow" label="最大泄洪流量@(m³/s)" :render-header="renderheader" width="115">
              </el-table-column>
              <el-table-column align="center" prop="dsfllv" label="设计洪水位@(m)" :render-header="renderheader" width="100">
              </el-table-column>
              <el-table-column align="center" prop="storage" label="总库容@(万m³)" :render-header="renderheader" width="70">
              </el-table-column>
              <el-table-column align="center" prop="waterArea" label="集雨面积@(k㎡)" :render-header="renderheader" width="85">
              </el-table-column>
              <el-table-column align="center" prop="spillwaySize" label="溢洪道尺寸@(m)" :render-header="renderheader" width="100">
              </el-table-column>
               <!-- 列表默认不显示经纬度坐标 -->
               <el-table-column align="center" prop="lng"  label="经度" min-width="150" v-if= "false">
              </el-table-column>
              <el-table-column align="center" prop="lat"  label="纬度" min-width="150" v-if= "false">
              </el-table-column>
              <el-table-column align="center" prop="hoistType" label="启闭机型式" width="100">
              </el-table-column>
              <el-table-column align="center" prop="culvertType" label="涵管型式" width="100">
              </el-table-column>
              <el-table-column align="center" prop="reinforcementTime" label="最近加固时间" width="150">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            :total="total"
        ></pager>
      </div>
    </div>
    <el-dialog
      class="abow_dialog"
      :title="status + '水库信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="160px" label-height="40px">
        <el-form-item label="水库名称:" prop="reservoirName">
          <el-input v-model="form.reservoirName"></el-input>
        </el-form-item>
        <el-form-item label="乡镇:" prop="adcdid">
          <el-select v-model="form.adcdid" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in mutiRanksAdcd"
              :key="'f'+item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属小流域:" prop="cacd">
          <el-select v-model="form.cacd" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in cacds"
              :key="'f'+item.cacd"
              :label="item.canm"
              :value="item.cacd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工程类别：" prop="reservoirScale">
          <el-select v-model="form.reservoirScale" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in reservoirScales"
              :key="'f'+item.name"
              :label="item.remark"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="经度:" prop="lng">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lat">
          <el-input v-model="form.lat"></el-input>
           <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
        <el-form-item label="所在河流：" prop="rvnm">
          <el-input v-model="form.rvnm"></el-input>
        </el-form-item>
        <el-form-item label="水库类型：" prop="rType">
          <el-select v-model="form.rType" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in rTypes"
              :key="'f'+item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主要挡水建筑物类型：">
          <el-select v-model="form.barrageType" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in barrageTypes"
              :key="'f'+item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="挡水主坝类型：">
          <el-select v-model="form.releaseType" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in releaseTypes"
              :key="'f'+item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主要泄洪建筑物型:">
          <el-input v-model="form.releaseBuildType"></el-input>
        </el-form-item>
        <el-form-item label="主坝坝高:" prop="flow">
          <el-input v-model="form.flow"></el-input>
          <label>(m)</label>
        </el-form-item>
        <el-form-item label="坝址多年平均径流量:" prop="damHeight">
          <el-input v-model="form.damHeight"></el-input>
          <label>(万m³/s)</label>
        </el-form-item>
        <el-form-item label="主坝坝长:" prop="damLength">
          <el-input v-model="form.damLength"></el-input>
          <label>(m)</label>
        </el-form-item>
        <el-form-item label="最大泄洪流量:" prop="maxFlow">
          <el-input v-model="form.maxFlow"></el-input>
          <label>(m³/s)</label>
        </el-form-item>
        <el-form-item label="设计洪水位:" prop="dsfllv">
          <el-input v-model="form.dsfllv"></el-input>
          <label>(m)</label>
        </el-form-item>
        <el-form-item label="总库容:" prop="storage">
          <el-input v-model="form.storage"></el-input>
          <label>(万m³)</label>
        </el-form-item>
        <el-form-item label="集雨面积:" prop="waterArea">
            <el-input v-model="form.waterArea"></el-input>
            <label>(km²)</label>
        </el-form-item>
        <el-form-item label="溢洪道尺寸:" prop="spillwaySize">
            <el-input v-model="form.spillwaySize"></el-input>
            <label>(m)</label>
        </el-form-item>
        <el-form-item label="启闭机型式:" >
          <el-input v-model="form.hoistType"></el-input>
        </el-form-item>
        <el-form-item label="涵管型式:" >
          <el-input v-model="form.culvertType"></el-input>
        </el-form-item>
        <el-form-item label="最近加固时间:" >
           <el-date-picker
            v-model="form.reinforcementTime"
            value-format="yyyy-MM-dd hh:mm:ss"
            format="yyyy-MM-dd hh:mm:ss"
            type="datetime"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import baseTypes from '@/store/types/base'
import TownName from '@/components/Townname/index.vue'
import Pager from '@/components/Pager'
import DrawPoint from '@/components/DrawPoint'
export default {
  components: {
    TownName,
    Pager,
    DrawPoint
  },
  data () {
    return {
      query: {
        adcdA: []
      },
      loading: false,
      height: 10,
      form: {},
      rules: {
        reservoirName: [
          { required: true, message: '水库名称不能为空' }
        ],
        rvnm: [
          { required: true, message: '所在河流不能为空' }
        ],
        adcdid: [
          { required: true, message: '请选择乡镇' }
        ],
        cacd: [
          { required: true, message: '请选择所属小流域' }
        ],
        reservoirScale: [
          { required: true, message: '请选择工程类别' }
        ],
        rType: [
          { required: true, message: '请选择水库类型' }
        ],
        flow: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damHeight: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damLength: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        maxFlow: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        dsfllv: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        storage: [
          { required: true, message: '总库容不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        waterArea: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        spillwaySize: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lng: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lat: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      addbtn: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      cPageIndex: '1',
      cPageSize: '100',
      tdata: [],
      multipleSelection: [],
      status: '新增',
      aDCD: '330324',
      mutiRanksAdcd: [],
      all: true,
      cacds: [],
      rTypes: [],
      barrageTypes: [],
      releaseTypes: [],
      reservoirScales: [],
      globalmapId: 'baseInfo',
      latlngarr: [],
      lat: 28.273886, // 新增初始经纬度坐标
      lng: 120.690968
    }
  },
  methods: {
    handleChangeAdd (data) {
      // this.form.lng = data.lng
      // this.form.lat = data.lat
      this.form.lng = this.$set(this.form, 'lng', data.lng)
      this.form.lat = this.$set(this.form, 'lat', data.lat)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    searchTheData () {
      this.pageIndex = 1 // 重置页码
      this.thedata()
    },
    // 乡镇选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.pageIndex = 1 // 重置页码
      this.query.adcd = townAdcd
      this.thedata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    getReservoirScaleName: function (row) {
      let reservoirScale = row.reservoirScale
      let option = this.reservoirScales.find(item => {
        return item.name === reservoirScale
      })
      let returnData = ''
      if (option !== undefined) {
        returnData = option.remark
      }
      return returnData
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thedata () {
      // this.$store.dispatch(scenceTypes.GET_RESERVOIR, { cacd: this.query.cacd, reservoirScale: this.query.reservoirScale, adcd: this.query.adcd, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
      //   this.tdata = data.results
      //   this.loading = false
      // })
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_RESERVOIR, { cacd: this.query.cacd, reservoirScale: 'Ⅰ,Ⅱ,Ⅲ,Ⅳ,Ⅴ', adcd: this.query.adcd, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.latlngarr = [] // 重置经纬度
      this.form = {}
      // this.form = Object.assign({}, { lat: this.lat, lng: this.lng })
      // this.latlngarr.push(this.lng, this.lat)
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      if (this.multipleSelection.length === 1) {
        this.latlngarr = [] // 重置经纬度
        this.status = '编辑'
        this.form = Object.assign({}, this.multipleSelection[0])
        this.addbtn = true
        this.latlngarr.push(this.form.lng, this.form.lat)
        this.Global.clearValidate(this, 'groupForm')
      } else {
        this.$alert('必需只选择一条信息', '提示')
      }
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的水库信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_RESERVOIR, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_RESERVOIR, this.form).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.loading = false
            this.addbtn = false
            this.form = {}
            this.multipleSelection = []
          }).catch(() => { this.loading = false })
        }
      })
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, { pageIndex: this.cPageIndex, pageSize: this.cPageSize }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    getDict (type) {
      this.$store.dispatch(baseTypes.GET_DICT, { type: type }).then(data => {
        switch (type) {
          case 'ReservoirType':
            this.rTypes = data
            break
          case 'BarrageType':
            this.barrageTypes = data
            break
          case 'ReleaseType':
            this.releaseTypes = data
            break
          case 'ReservoirScale':
            this.reservoirScales = data
            break
          default:
        }
      }).catch(() => {})
    },
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.thedata()
    this.getCacd()
    this.getMutiRanksAdcd()
    this.getDict('ReservoirType')
    this.getDict('BarrageType')
    this.getDict('ReleaseType')
    this.getDict('ReservoirScale')
  },
  mounted () {
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence .skt{
  height: calc(100% - 77px);
}
.scence >>> .el-dialog__body {
  height: 86%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content{
  width: 285px !important;
}
.scence >>> .el-dialog__body .el-form-item:nth-of-type(2) .el-form-item__content .el-input,
.scence >>> .el-dialog__body .el-form-item:nth-of-type(3) .el-form-item__content .el-input,
.scence >>> .el-dialog__body .el-form-item:nth-of-type(4) .el-form-item__content .el-input,
.scence >>> .el-dialog__body .el-form-item:nth-of-type(8) .el-form-item__content .el-input,
.scence >>> .el-dialog__body .el-form-item:nth-of-type(9) .el-form-item__content .el-input,
.scence >>> .el-dialog__body .el-form-item:nth-of-type(10) .el-form-item__content .el-input {
    width: 100% !important;
}
.scence >>> .el-dialog {
  margin: 70px auto 0 !important;
  height: 89%;
  z-index: 2003!important;
}
/* .scence >>> .el-dialog__body{
  height: 340px !important;
}*/
.scence >>> .el-form-item{
  width: 46% !important;
  margin-left: 25px;
}
.countryList{
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.global_map {
  position: absolute;
  right: 30px;
  top: 5px;
}
</style>
